import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { applyActionCode } from 'firebase/auth';
import { auth } from '../firebase';
import './Auth.css';

export default function AuthAction() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const mode = searchParams.get('mode');
    const oobCode = searchParams.get('oobCode');

    if (mode === 'verifyEmail' && oobCode) {
      applyActionCode(auth, oobCode)
        .then(() => setStatus('success'))
        .catch((err) => {
          if (err.code === 'auth/invalid-action-code') {
            setStatus('already');
          } else {
            setStatus('error');
          }
        });
    } else if (mode === 'resetPassword') {
      window.location.href = `https://plumly-fe6f7.firebaseapp.com/__/auth/action?${searchParams.toString()}`;
    } else {
      setStatus('error');
    }
  }, [searchParams]);

  useEffect(() => {
    if (status !== 'success' && status !== 'already') return;
    if (countdown <= 0) {
      window.location.href = '/auth';
      return;
    }
    const timer = setTimeout(() => setCountdown(c => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [status, countdown]);

  return (
    <div className="auth-page">
      <div className="auth-bg">
        <div className="auth-circle auth-circle-1"></div>
        <div className="auth-circle auth-circle-2"></div>
      </div>
      <div className="auth-content">
        <div className="auth-brand">
          <h1 className="auth-logo">Plumly</h1>
          <p className="auth-tagline">Swipe, découvre, lis.</p>
        </div>
        <div className="auth-card" style={{ textAlign: 'center' }}>

          {status === 'loading' && (
            <>
              <div style={{ fontSize: 52, marginBottom: 16 }}>⏳</div>
              <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8 }}>Vérification en cours...</h2>
              <p style={{ color: '#888', fontSize: 14 }}>Un instant, on active ton compte.</p>
            </>
          )}

          {(status === 'success' || status === 'already') && (
            <>
              <div style={{ fontSize: 52, marginBottom: 16 }}>✅</div>
              <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 8, color: '#2c2a27' }}>
                Email vérifié !
              </h2>
              <p style={{ color: '#888', fontSize: 14, lineHeight: 1.7, marginBottom: 24 }}>
                Ton compte Plumly est maintenant actif.<br />
                Bienvenue dans la communauté ! 🪶
              </p>
              <p style={{ color: '#888', fontSize: 13, lineHeight: 1.7, marginBottom: 20 }}>
                Retourne sur l'onglet où tu t'es inscrit et clique sur<br />
                <strong style={{ color: '#2c2a27' }}>"J'ai vérifié mon email"</strong> pour continuer.
              </p>
              <button
                className="btn btn-primary btn-full"
                style={{ marginBottom: 12 }}
                onClick={() => window.location.href = '/auth'}
              >
                Se connecter →
              </button>
              <p style={{ fontSize: 12, color: '#bbb', marginTop: 8 }}>
                Redirection dans {countdown}s...
              </p>
            </>
          )}

          {status === 'error' && (
            <>
              <div style={{ fontSize: 52, marginBottom: 16 }}>❌</div>
              <h2 style={{ fontSize: 20, fontWeight: 700, marginBottom: 8, color: '#c27a7a' }}>
                Lien invalide ou expiré
              </h2>
              <p style={{ color: '#888', fontSize: 14, lineHeight: 1.7, marginBottom: 24 }}>
                Ce lien de vérification n'est plus valide.<br />
                Reconnecte-toi pour en recevoir un nouveau.
              </p>
              <button
                className="btn btn-primary btn-full"
                onClick={() => window.location.href = '/auth'}
              >
                Retour à la connexion
              </button>
            </>
          )}

        </div>
      </div>
    </div>
  );
}